import * as React from 'react';

function SvgLogoYoutubeOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinejoin: "round", strokeWidth: 1.6, d: "M21.872 7.313c0-1.758-1.293-3.173-2.891-3.173-2.165-.1-4.372-.14-6.628-.14h-.703c-2.25 0-4.461.04-6.626.14-1.594 0-2.887 1.423-2.887 3.18A58.115 58.115 0 002 11.494a60.49 60.49 0 00.133 4.176c0 1.758 1.293 3.184 2.887 3.184 2.274.106 4.606.153 6.978.149 2.375.008 4.701-.042 6.977-.149 1.598 0 2.891-1.426 2.891-3.184.094-1.394.137-2.785.133-4.18a56.81 56.81 0 00-.127-4.176zm-11.785 8.012V7.65l5.665 3.836-5.665 3.84z" })));
}

export default SvgLogoYoutubeOutline;
